import { useState, useRef } from 'react';
import { ChatContext, chatConversationData as defaultData, Message, ConvoNode } from '@/types/chatBot';
import { Company } from '@/types';

export const useChatbot = () => {
  const chatBodyRef = useRef<HTMLDivElement>(null);

  // Chatbot states - extracted exactly from Customer.Layout.tsx
  const [companyDetails, setCompanyDetails] = useState<Company | null>(null);
  const [formData, setFormData] = useState<ChatContext>({});
  const [currentKey, setCurrentKey] = useState<string>('queryType'); // Skip user info questions
  const [conversationData, setConversationData] = useState<Record<string, ConvoNode>>(defaultData);
  const [messages, setMessages] = useState<Message[]>([
    { sender: 'bot', text: conversationData?.[currentKey]?.text || '', options: conversationData[currentKey].options }
  ]);
  const [input, setInput] = useState<string>('');
  const [error, setError] = useState<string>('');

  return {
    chatBodyRef,
    companyDetails,
    setCompanyDetails,
    formData,
    setFormData,
    currentKey,
    setCurrentKey,
    conversationData,
    setConversationData,
    messages,
    setMessages,
    input,
    setInput,
    error,
    setError
  };
}; 